var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ is_width: _vm.isWidth },attrs:{"data-stat":'接龙分享_' + _vm.activityId},on:{"click":_vm.handleShare}},[_vm._t("button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }